<template>
<w-sliding-popup ref="slidingPopup" type="setting" :title="title" width="500px" @close="onClose">
  <el-form slot="content" :model="oidData" :rules="rules" label-position="top" :ref="formName">
    <!-- 기본 정보 -->
    <div class="title-bar title-h4">기본 정보</div>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="사용자정의 자원 ID" prop="rscId">
          <el-input :disabled="!isAddMode" v-model="oidData.rscId"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="사용자정의 자원 이름" prop="rscName">
          <el-input v-model="oidData.rscName"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="자원 단위" prop="rscUnit">
          <el-input v-model="oidData.rscUnit"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="결과 형태">
          <el-select :disabled="!isAddMode" v-model="oidData.rscDatatypeId" style="width:100%" @change="selectRsltTypeChange">
            <el-option v-for="item in resultTypeList" :key="item.rscDatatypeId" :label="item.rscDatatypeName" :value="item.rscDatatypeId"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="그룹 통계 구분" prop="groupstatType">
          <el-select v-model="oidData.groupstatType" style="width:100%">
            <el-option v-for="item in groupstatTypeList" :key="item.basicinfoSubid" :label="item.basicinfoSubname" :value="item.basicinfoSubid"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="이벤트 메시지 포멧" prop="eventMessageFormatId">
          <el-select v-model="oidData.eventMessageFormatId" style="width:100%">
            <el-option v-for="item in eventMessageFormatList" :key="item.eventMessageFormatId" :label="item.eventMessageFormatName" :value="item.eventMessageFormatId"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row v-if="isAddMode" :gutter="20">
      <el-col :span="12">
        <el-form-item label="이벤트 판단 타입" prop="eventJudgeConditionTypeId">
          <el-select v-model="oidData.eventJudgeConditionTypeId" style="width:100%">
            <el-option v-for="item in filterRsltList" :key="item.basicinfoSubid" :label="item.basicinfoSubname" :value="item.basicinfoSubid"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row class="mr-b25">
      <el-col :span="24">
        <el-form-item label="사용자 정의 OID" prop="rscSnmpOid">
          <el-input v-model="oidData.rscSnmpOid"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <!-- 표현값 설정 -->
    <div class="title-bar title-h4">표현 값 설정</div>
    <div v-for="(item, index) in objRscValueAliasData" :key="index">
      <el-form-item style="display:inline-block; width:calc(50% - 19.25px);" :label="index === 0 ? '자원 값' : null" :validate-status="item.resultValueValidateState">
        <el-input v-model="item.resultValue" @blur="validateValueAlias" />
      </el-form-item>
      <el-form-item style="display:inline-block; width:calc(50% - 19.25px);" :label="index === 0 ? '표현 값' : null" :validate-status="item.valueAliasValidateState">
        <el-input v-model="item.valueAlias" @blur="validateValueAlias" />
      </el-form-item>
      <el-button v-if="index === objRscValueAliasData.length - 1" @click="addValueAlias(item)"><i class="fas fa-plus" /></el-button>
      <el-button v-else @click="deleteValueAlias(index)"><i class="fas fa-minus" /></el-button>
    </div>
  </el-form>
  <el-row slot="footer" type="flex" justify="center">
    <el-button size="large" class="mr-r4" type="solid" @click="saveUserDefineOid">저장</el-button>
    <el-button size="large" @click="close">취소</el-button>
  </el-row>
</w-sliding-popup>
</template>

<script>
import { filter, cloneDeep, forEach, differenceBy, findIndex, isNil } from 'lodash';
import { isEmpty } from '@/utils/basic';
import msgUtil from '@/utils/message';
// import { validateOid } from '@/utils/string';
import RscSettingsAPI from '@/api/settings/common/rsc-settings';
import NetdeviceSettingAPI from '@/api/settings/netdevice/netdevice-settings';
import BasicinfoSubAPI from '@/api/model/basicinfo-sub';

export default {
  name: 'WUserDefinePopup',
  data() {
    return {
      isAddMode: true,
      title: null,
      selectResultType: '',
      selectEventJudge: '',
      eventJudgeInfoList: [],
      resultTypeList: [],
      filterRsltList: [],
      groupstatTypeList: [],
      eventMessageFormatList: [],
      objRscValueAliasData: [],
      originalObjRscValueAliasData: [],
      popupType: null,
      vendorModelName: 'vendorModelInfoForm',
      formName: 'oidDataForm',
      managetypeId: 'NMS',
      rsctypeId: 'USERDEFINE',
      oidData: {},
      selectPhysicalNode: {},
      validateState: {
        validating: 'validating',
        error: 'error',
      },
      rules: {
        rscId: {
          required: true,
          trigger: 'blur',
          validator: this.validatorForRscId,
        },
        rscName: {
          required: true,
          trigger: 'blur',
          message: '값을 입력해주세요',
        },
        rscSnmpOid: {
          required: true,
          trigger: 'blur',
          message: '값을 입력해주세요',
        },
        selectEventJudge: {
          required: true,
          trigger: 'cahnge',
          validator: this.validateEventJudge,
        },
      },
    };
  },
  computed: {
    /**
     * 선택한 obj의 objId
     * @author Ju
     * @return {[type]} [description]
     */
    selectedObjId() {
      return isEmpty(this.selectPhysicalNode) ? null : this.selectPhysicalNode.obj.objId;
    },
  },
  methods: {
    /**
     * 사용자 정의 OID 팝업을 띄운다.
     * @author Ju
     * @param  {[type]} selectedObjNode [description]
     * @param  {[type]} oidData         [description]
     * @return {[type]}                 [description]
     */
    open(selectedObjNode, oidData) {
      this.selectPhysicalNode = selectedObjNode;
      let title;
      if (isEmpty(oidData)) {
        this.isAddMode = true;
        title = '사용자 정의 OID 추가';
        this.oidData = {
          managetypeId: this.managetypeId,
          rsctypeId: this.rsctypeId,
          rscId: null,
          rscName: null,
          rscUnit: null,
          rscSnmpOid: null,
          eventJudgeConditionTypeId: null,
          rscDatatypeId: null,
          groupstatType: null,
          eventMessageFormatId: null,
        };
        this.objRscValueAliasData = this.getObjRscValueAliasInitData();
      } else {
        this.isAddMode = false;
        title = `${oidData.rscName} 정보`;
        this.oidData = oidData;
        this.loadObjRscValueAliasData();
      }
      this.title = title;
      this.loadResultType();
      this.loadEventMessageFormatList();
      this.loadGroupstatTypeList();
      this.$refs.slidingPopup.open();
    },
    /**
     * 사용자 정의 OID 팝업을 닫는다.
     * @author Ju
     * @return {[type]} [description]
     */
    close() {
      this.$refs.slidingPopup.close();
    },
    /**
     * 팝업 close 이벤트 핸들러
     * @author Ju
     * @return {[type]} [description]
     */
    onClose() {
      this.$refs[this.formName].resetFields();
      this.$refs[this.formName].clearValidate();
    },
    /**
     * [loadResultType 결과 형태 목록을 불러온다.]
     * @author yelim
     */
    loadResultType() {
      const numericList = ['INTEGER', 'DOUBLE', 'LONG', 'DECIMAL', 'NUMERIC'];
      NetdeviceSettingAPI.getRscDatatypeList()
        .then((result) => {
          if (result.data.success) {
            const resultData = result.data.data;
            this.resultTypeList = resultData;
            this.resultTypeList.forEach((item) => {
              // 결과 형태 콤보박스 선택시 보여주어야 하는 이벤트 판단 타입을 구분하기 위해 조건키값을 추가한다.
              const findTypeIndex = numericList.findIndex((typeId) => typeId === item.rscDatatypeId);
              if (findTypeIndex > -1) {
                item.isNumeric = true;
              } else {
                item.isNumeric = false;
              }
            });
            if (this.isAddMode) {
              this.oidData.rscDatatypeId = resultData[0].rscDatatypeId;
            }
            this.loadEventJudgeList();
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '결과 형태 정보', false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '결과 형태 정보', false));
        });
    },
    /**
     * [loadEventJudgeList 이벤트 판단 타입 목록을 불러온다.]
     * @author yelim
     */
    loadEventJudgeList() {
      NetdeviceSettingAPI.getEventJudgeTypes()
        .then((result) => {
          if (result.data.success) {
            this.eventJudgeInfoList = result.data.data;
            this.eventJudgeInfoList.forEach((item) => {
              // 결과 형태가 STRING, TEXT, BOOLEAN인 경우 이벤트 판단 타입을 달리 보여주기 위해
              // 조건 키값을 추가한다.
              if (item.basicinfoSubid === 'ALL_OF_THEM' || item.basicinfoSubid === 'ONE_OF_THEM') {
                item.isStringType = true;
              } else {
                item.isStringType = false;
              }
            });
            this.checkNumericType();
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '이벤트 판단 타입 정보', false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '이벤트 판단 타입 정보', false));
        });
    },
    /**
     * 표현 값 설정 정보를 조회한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadObjRscValueAliasData() {
      NetdeviceSettingAPI.getObjRscValueAliasList(this.oidData)
        .then((result) => {
          if (result.data.success) {
            if (isEmpty(result.data.data)) {
              this.objRscValueAliasData = this.getObjRscValueAliasInitData();
              this.originalObjRscValueAliasData = [];
            } else {
              this.originalObjRscValueAliasData = result.data.data;
              const data = cloneDeep(result.data.data);
              forEach(data, (item) => {
                item.resultValueValidateState = this.validateState.validating;
                item.valueAliasValidateState = this.validateState.validating;
              });
              this.objRscValueAliasData = data;
            }
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '표현 값 설정', false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '표현 값 설정', false));
        });
    },
    /**
     * 표현 값 설정 초기 데이터 반환한다.
     * @author Ju
     * @return {[type]} [description]
     */
    getObjRscValueAliasInitData() {
      return [
        {
          resultValue: null,
          valueAlias: null,
          resultValueValidateState: this.validateState.validating,
          valueAliasValidateState: this.validateState.validating,
        },
      ];
    },
    /**
     * [checkNumericType 선택한 결과 형태에 따른 상이한 이벤트 판단 타입을 제공한다.]
     * @author yelim
     */
    checkNumericType() {
      const rscDatatypeId = this.oidData.rscDatatypeId;
      if (this.resultTypeList.length > 0) {
        const findData = this.resultTypeList.find((item) => item.rscDatatypeId === rscDatatypeId);
        if (findData && !findData.isNumeric) {
          this.filterRsltList = filter(this.eventJudgeInfoList, ['isStringType', true]);
        } else {
          this.filterRsltList = filter(this.eventJudgeInfoList, ['isStringType', false]);
        }
        if (!isEmpty(this.filterRsltList)) {
          this.oidData.eventJudgeConditionTypeId = this.filterRsltList[0].basicinfoSubid;
        }
      }
    },
    /**
     * 결과 형태 변경 이벤트 핸들러
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    selectRsltTypeChange(value) {
      this.selectResultType = value;
      this.checkNumericType();
    },
    /**
     * [saveUserDefineOid 수정/추가한 사용자 정의 OID 정보를 저장한다.]
     * @author yelim
     */
    saveUserDefineOid() {
      this.$refs[this.formName].validate((valid) => {
        if (valid && this.validateValueAlias()) {
          const objId = this.selectedObjId;
          const params = {
            ...this.oidData,
            objId,
          };
          const objRscValueAliasList = this.getObjRscValueAliasListForSave();

          const target = '사용자 정의 OID';
          const action = msgUtil.action.SAVE;
          if (this.isAddMode) {
            if (!isEmpty(objRscValueAliasList)) {
              params.editedObjRscValueAliasData = {
                INSERT: objRscValueAliasList,
              };
            }
            NetdeviceSettingAPI.addUserDefineOid(params)
              .then((result) => {
                if (result.data.success) {
                  this.dataList = result.data.data;
                  this.$message(msgUtil.getResultMsgData(action, target, true));
                  this.close();
                  this.$emit('reload-data');
                } else {
                  this.$message(msgUtil.getResultMsgData(action, target, false));
                }
              })
              .catch(() => {
                this.$message(msgUtil.getResultMsgData(action, target, false));
              });
          } else {
            // 표현 설정 값 저장 객체 가공
            const insertData = [];
            const updateData = [];
            const deleteData = differenceBy(this.originalObjRscValueAliasData, objRscValueAliasList, 'resultValue');
            forEach(objRscValueAliasList, (modified) => {
              let exist = false;
              forEach(this.originalObjRscValueAliasData, (original) => {
                if (!exist && original.resultValue === modified.resultValue) {
                  if (original.valueAlias !== modified.valueAlias) {
                    updateData.push(modified);
                  }
                  exist = true;
                }
              });
              if (!exist) {
                insertData.push(modified);
              }
            });
            params.editedObjRscValueAliasData = {
              INSERT: insertData,
              UPDATE: updateData,
              DELETE: deleteData,
            };

            NetdeviceSettingAPI.updateUserDefineOid(params)
              .then((result) => {
                if (result.data.success) {
                  this.dataList = result.data.data;
                  this.$message(msgUtil.getResultMsgData(action, target, true));
                  this.close();
                  this.$emit('reload-data');
                } else {
                  this.$message(msgUtil.getResultMsgData(action, target, false));
                }
              })
              .catch(() => {
                this.$message(msgUtil.getResultMsgData(action, target, false));
              });
          }
        } else {
          this.$message(msgUtil.getCustomMsgData('값을 올바르게 설정해주세요.'));
        }
      });
    },
    /**
     * 표현 값 설정 정보를 추가한다.
     * @author Ju
     */
    addValueAlias(data) {
      if (isEmpty(data.resultValue)) {
        this.$message(msgUtil.getRequireMsgData(msgUtil.action.INPUT, '자원 값'));
        return;
      } else if (isEmpty(data.valueAlias)) {
        this.$message(msgUtil.getRequireMsgData(msgUtil.action.INPUT, '표현 값'));
        return;
      }
      this.objRscValueAliasData.push({
        resultValue: null,
        valueAlias: null,
      });
      this.validateValueAlias();
    },
    /**
     * 마지막 표현 설정 값을 제거한다.
     * @author Ju
     * @return {[type]} [description]
     */
    deleteValueAlias(index) {
      this.objRscValueAliasData.splice(index, 1);
    },
    /**
     * 표현 갑 설정 유효성 검사
     * 표현 값 설정이 많지 않을 갓이라는 전제하에 표현 값 별 validate 상태 설정과 전체 validate 체크 기능을 분리하지 않음.
     * @author Ju
     * @param  {[type]} data  [description]
     * @param  {[type]} index [description]
     * @return {[type]}       [description]
     */
    validateValueAlias() {
      const length = this.objRscValueAliasData.length;
      let valid = true;
      for (let i = 0; i < length; i += 1) {
        const data = this.objRscValueAliasData[i];
        let isValid = true;
        if (i !== length - 1 && isEmpty(data.resultValue)) {
          data.resultValueValidateState = this.validateState.error;
          data.valueAliasValidateState = this.validateState.validating;
          isValid = false;
        } else if (i !== length - 1 && !isEmpty(data.resultValue) && isEmpty(data.valueAlias)) {
          data.resultValueValidateState = this.validateState.validating;
          data.valueAliasValidateState = this.validateState.error;
          isValid = false;
        } else {
          data.resultValueValidateState = this.validateState.validating;
          data.valueAliasValidateState = this.validateState.validating;
        }

        if (!isEmpty(data.resultValueValidateState)) {
          for (let si = 0; si < length; si += 1) {
            if (i !== si && data.resultValue === this.objRscValueAliasData[si].resultValue) {
              data.resultValueValidateState = this.validateState.error;
              break;
            }
          }
        }

        if (valid && !isValid) {
          valid = false;
        }
      }
      return valid;
    },
    /**
     * DB 저장하기 위한 표현 값 설정 데이터를 가공하여 반환한다.
     * @author Ju
     * @return {[type]} [description]
     */
    getObjRscValueAliasListForSave() {
      const objRscValueAliasList = [];
      forEach(this.objRscValueAliasData, (item) => {
        if (!isEmpty(item.resultValue) && !isEmpty(item.valueAlias)) {
          objRscValueAliasList.push({
            objId: this.selectedObjId,
            managetypeId: this.managetypeId,
            rsctypeId: this.rsctypeId,
            rscId: this.oidData.rscId,
            resultValue: item.resultValue,
            valueAlias: item.valueAlias,
          });
        }
      });
      return objRscValueAliasList;
    },
    /**
     * [getValidateOid form item의 OID를 Valiedation 수행한다.]
     * 12.03 Ju OID 값에 수식 들어갈 수 있으므로 validation 체크 제거
     * @author yelim
     */
    // getValidateOid(rule, value, callback) {
    //   if (validateOid(value)) {
    //     callback();
    //   } else {
    //     callback(new Error('올바른 OID 형식을 입력해주세요'));
    //   }
    // },
    /**
     * 이벤트 판단 타입 유효성검사
     * @param  {[type]}   rule     [description]
     * @param  {[type]}   value    [description]
     * @param  {Function} callback [description]
     * @return {[type]}            [description]
     * @author jda
     */
    validateEventJudge(rule, value, callback) {
      if (isEmpty(this.selectEventJudge)) {
        callback(new Error('이벤트 판단 타입을 선택해주십시오.'));
      } else {
        callback();
      }
    },
    /**
     * 자원 아이디 유효성 검사
     * @author Ju
     * @param  {[type]}   rule     [description]
     * @param  {[type]}   value    [description]
     * @param  {Function} callback [description]
     * @return {[type]}            [description]
     */
    validatorForRscId(rule, value, callback) {
      if (!this.isAddMode) {
        callback();
      } else if (isEmpty(value)) {
        callback(new Error('값을 입력해주세요'));
      } else {
        RscSettingsAPI.checkRscIdValidation({
          managetypeId: this.managetypeId,
          rsctypeId: this.rsctypeId,
          rscId: value,
        })
          .then((response) => {
            if (response.data.data) {
              callback();
            } else {
              callback(new Error('이미 사용 중인 아이디 입니다.'));
            }
          })
          .catch(() => {
            callback(new Error('자원 아이디 중복 여부를 확인하지 못하였습니다.'));
          });
      }
    },
    loadEventMessageFormatList() {
      RscSettingsAPI.getEventMessageFormatListByManagetypeId({
        managetypeId: 'NMS',
        managetypeKey: 'ND',
      }).then((response) => {
        const result = response.data.data;
        if (!isNil(result)) {
          this.eventMessageFormatList = cloneDeep(result);
          if (this.isAddMode) {
            this.oidData.eventMessageFormatId = cloneDeep(result)[0].eventMessageFormatId;
          }
        }
      });
    },
    loadGroupstatTypeList() {
      BasicinfoSubAPI.getList('GROUPSTATTYPE').then((response) => {
        const result = response.data.data;
        if (!isNil(result)) {
          this.groupstatTypeList = cloneDeep(result);
          if (this.isAddMode) {
            this.oidData.groupstatType = cloneDeep(result)[0].basicinfoSubid;
          }
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/netdevice/OidSettings/UserDefineOidSettings/popup/UserDefinePopup.vue